import { Sort } from '@Entities/search'

export const PAGINATION = {
    paginationLimit: 10000,
}

export const ALPHABETICAL_WORK_TITLE_SORT: Sort[] = [
    { field: 'title.keyword', direction: 'asc' },
    { field: 'property_id', direction: 'asc' },
]
